import React, { Component } from 'react';
import styled from 'styled-components';
import { Link, withRouter } from 'react-router-dom';
import { SwitchTabs } from 'components/layouts';
import { getData, dataDetailReceived, dataReceived, documentDetailError } from 'datahub/actions';
import { setLanguage } from 'filters/actions';
import { connect } from 'react-redux';
import { Transition } from 'react-transition-group';
import { filterData } from 'filters/selectors';
import dataService from 'api/dataService';
import { strings } from 'config';

class LanguageSwitcher extends Component {
  state = {
    selected: 'radio-1',
    isOpen: false
  };

  handleDropdownMenu(dropdownState) {
    this.setState({
      isOpen: dropdownState
    });
  }

  componentDidMount() {
    const selectedLang = strings.getLanguage();
    this.setState({
      selectedValue: selectedLang === 'en' ? 'English' : 'नेपाली'
    });
  }

  componentWillReceiveProps(nextProps) {
    // const { filters } = nextProps;
    // const selectedLang = strings.getLanguage();
    // this.setState({
    //   selectedValue: selectedLang === 'en' ? 'English' : 'Nepali'
    // });
  }

  handleChange(dropdownValue, dropdownLabel) {
    this.setState(
      {
        isOpen: false,
        selectedValue: dropdownLabel
      },
      () => {
        this.props.onSortChange(dropdownValue);
      }
    );
  }

  setLanguage = (label, lang) => {
    const { filters, handleFilters } = this.props;
    strings.setLanguage(lang);

    handleFilters(filters, lang);
  };

  render() {
    const transitionStyles = {
      entered: {
        opacity: 1,
        visibility: 'visible',
        transform: 'translateY(0)'
      }
    };

    const switchItems = [{ value: 'np', label: 'ने' }, { value: 'en', label: 'EN' }];

    return (
      <SwitchTabs
        onChangeLang={this.setLanguage}
        switchItems={switchItems}
        name="language-switcher"
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    filters: state.filters
  };
};

const mapDispatchToProps = dispatch => ({
  handleFilters: (filters, lang) => {
    dispatch(setLanguage(lang));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(LanguageSwitcher);

const DropdownButton = styled.span`
  position: relative;
  display: inline-block;
  border-radius: 2px;
  color: #333;
  font-size: 14px;
  cursor: pointer;
  padding: 8px 16px;
`;

const Title = styled.span`
  color: #fff;
  font-size: ${props => (props.lang === 'en' ? '14px' : '16px')};
  cursor: pointer;
`;

const DropdownIcon = styled.span`
  border-color: ${props =>
    props.isOpen ? `transparent transparent #fff` : `#fff transparent transparent;`}
    border-width: ${props => (props.isOpen ? '0 4px 4px' : '4px 4px 0')};
  border-style: solid;
  display: inline-block;
  vertical-align: middle;
  margin-left: 6px;
`;

const Dropdown = styled.span`
  position: relative;
`;

const DropdownMenu = styled.div`
  padding-top: 6px;
  position: absolute;
  top: 100%;
  right: 0;
  width: 100%;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-4px);
  transition: all 300ms ease-in-out;

  .dropdown-list {
    background-color: ${props => props.theme.primary.raju};
    border-radius: 4px;
    box-shadow: 0 8px 40px -8px rgba(0, 0, 0, 0.15);

    .dropdown-list-item {
      display: block;
      color: #4a4a4a;
      font-size: 14px;
      transition: all 0.2s ease-in;
      line-height: 1.4;
      cursor: pointer;
      &:not(:last-child) {
        border-bottom: 1px solid #e4eaeb;
      }
      &:hover {
        color: ${props => props.theme.primary.ujyaalo};
        cursor: pointer;
      }

      &:first-child {
        > a {
          font-size: 16px;
        }
      }

      > a {
        color: #4a4a4a;
        white-space: nowrap;
        padding: 6px 12px;
        display: block;
        &.active {
          color: ${props => props.theme.teals.tilicho};
        }

        &:hover {
          color: ${props => props.theme.teals.tilicho};
          cursor: pointer;
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/layouts/languageSwitcher/languageSwitcher.js